import React from "react";
import { Card } from "react-bootstrap";
// Impor Highcharts secara langsung untuk mengakses tipenya
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { format } from "date-fns";

// Interface/tipe data tidak berubah
interface MonthlyDataItem {
    month: string;
    name: string;
    nb_reservations: number;
}

interface SourceItem {
    name: string;
    color: string;
}

interface ReportSalesMonthlyResponseV4 {
    data: MonthlyDataItem[];
    total_source: SourceItem[];
}

interface ReportSalesMonthlyHighChartProps {
    data: ReportSalesMonthlyResponseV4;
}

const ReportSalesMonthlyHighChart: React.FC<ReportSalesMonthlyHighChartProps> = ({ data }) => {

    const pivotedData = data.data.reduce<Record<string, Record<string, number | string>>>((acc, item) => {
        const formattedMonth = format(new Date(`${item.month}-01`), "MMM yyyy");

        if (!acc[formattedMonth]) {
            acc[formattedMonth] = { month: formattedMonth };
        }
        acc[formattedMonth][item.name] = item.nb_reservations;
        return acc;
    }, {});

    const chartDataValues = Object.values(pivotedData);
    const categories = chartDataValues.map(item => item.month as string);

    // === PERBAIKAN DI SINI ===
    // Kita secara eksplisit mendefinisikan tipe objek yang dibuat di dalam .map()
    // sebagai Highcharts.SeriesSplineOptions.
    const series = data.total_source.map((source): Highcharts.SeriesSplineOptions => ({
        type: 'spline', // Sekarang TypeScript tahu ini adalah literal 'spline', bukan string
        name: source.name,
        color: source.color,
        data: chartDataValues.map(d => (d[source.name] as number) || 0),
        marker: {
            symbol: 'circle'
        }
    }));

    const options: Highcharts.Options = {
        chart: {
            type: 'spline'
        },
        title: {
            text: "Graph of Reservations in the Last 12 Months"
        },
        xAxis: {
            categories: categories,
            title: {
                text: "Month"
            },
            crosshair: true
        },
        yAxis: {
            title: {
                text: "Number of Reservations"
            },
            crosshair: true
        },
        tooltip: {
            shared: true,
        },
        plotOptions: {
            spline: {
                marker: {
                    enabled: true,
                    radius: 4,
                    lineColor: '#666666',
                    lineWidth: 1
                }
            }
        },
        // Variabel 'series' sekarang memiliki tipe yang benar
        series: series,
        credits: {
            enabled: false
        }
    };

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </Card.Body>
        </Card>
    );
};

export default ReportSalesMonthlyHighChart;